import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function ForbiddenPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-gray-50 py-16 px-4">
      <SEOHead
        title="403 – Adgang nægtet – Vognmand & Entreprenør DBM aps"
        description="Du har ikke adgang til denne side."
      />

      <div className="max-w-md w-full bg-white p-8 sm:p-10 rounded shadow-md border border-gray-200 text-center">
        <div className="text-black font-black text-6xl mb-2">403</div>
        <h1 className="text-2xl font-bold text-gray-900 uppercase tracking-tight mb-4">
          Adgang nægtet
        </h1>
        <p className="text-gray-600 text-sm mb-8 leading-relaxed">
          Du har ikke adgang til at se denne side eller ressource.
        </p>

        <Link
          to="/"
          className="inline-block bg-gray-900 hover:bg-black text-white font-bold px-8 py-3 rounded uppercase tracking-wider text-xs transition-colors shadow-md"
        >
          Tilbage til forsiden
        </Link>
      </div>
    </div>
  );
}
